import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetTasksQuery } from "../../features/Task/taskApi";
import TaskItem from "./components/TaskItem";

export default function ContentContainer() {
  const activeProjects = useSelector((state) => state.projects.activeProjects);
  const searchValue = useSelector((state) => state.tasks.search);
  const { data: tasks, isError, isLoading } = useGetTasksQuery();
  const tasksFilteredByProject = tasks?.filter((task) =>
    activeProjects.includes(task.project.projectName)
  );
  const tasksFilteredBySearch =
    tasksFilteredByProject?.filter((task) =>
      task.taskName.toLowerCase().startsWith(searchValue.toLowerCase())
    ) || [];

  return (
    <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <div className="justify-between mb-10 space-y-2 md:flex md:space-y-0">
          <Link to="/add-task" className="lws-addnew group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6 group-hover:text-indigo-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>{" "}
            <span className="group-hover:text-indigo-500">Add New</span>
          </Link>
        </div>
        <div className="lws-task-list">
          {isLoading && <div>Loading...</div>}
          {isError && <div>Error</div>}
          {!tasksFilteredBySearch.length ||
            tasksFilteredBySearch.map((task) => (
              <TaskItem task={task} key={task.id} />
            ))}
        </div>
      </main>
    </div>
  );
}
